import React, { useEffect } from 'react';
import Confetti from 'react-confetti';

interface ConfettiWithTimerProps {
  showConfetti: boolean;
  setShowConfetti: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConfettiWithTimer: React.FC<ConfettiWithTimerProps> = ({
  showConfetti,
  setShowConfetti,
}) => {
  useEffect(() => {
    if (showConfetti) {
      const timer = window.setTimeout(() => {
        setShowConfetti(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showConfetti, setShowConfetti]);

  if (!showConfetti) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <Confetti
        numberOfPieces={300}
        recycle={false}
        gravity={0.3}
        width={window.innerWidth}
        height={window.innerHeight}
      />
    </div>
  );
};

export default ConfettiWithTimer;
